export default __webpack_public_path__ + "static/media/bgimage3.768cf030.jpg";